export const formBackground =
  'linear-gradient(270deg, rgba(0,20,36,1) 0%, rgba(31,196,173,1) 0%, rgba(76,169,238,1) 100%)';
export const ddStyle = {
  padding: 8,
  borderColor: 'currentcolor',
  fontSize: 16,
};

export const FULL_HEIGHT = '100vh';
export const FULL_WIDTH = '100vw';
export const DEFAULT_ELEVATION = 0;
export const DEFAULT_SHADOW = 3;
export const GRID_FORM_HALF_PAPER_STYLE = {
  height: '50vh',
  width: '80vw',
};
export const GRID_FORM_FULL_PAPER_STYLE = {
  height: '80vh',
  width: '100vw',
};
export const DEFAULT_FADE_DELAY = '200ms';
export const DEFAULT_BORDER_RADIUS = 5;
export const FORM_BREAKER = 6;
export const GRID_COLS = 12;
export const UPDATE_ERROR_MESSAGE = 'Failed to update';
export const UPDATE_SUCCESS_MESSAGE = 'Modified successfully';
export const ADD_ERROR_MESSAGE = 'Failed to add';
export const ADD_SUCCESS_MESSAGE = 'Added successfully';
export const DELETE_SUCCESS_MESSAGE = 'Removed successfully';
export const DELETE_ERROR_MESSAGE = 'Failed to delete';
export const RESTORE_SUCCESS_MESSAGE = 'Restored successfully';
export const RESTORE_ERROR_MESSAGE = 'Failed to restore';
export const HARDWARE = 'Hardware';
export const HARDWARE_TYPE = 'Hardware Type';
export const ORG_USER = 'User';
export const DEFAULT_MODULE_NAME = 'Aktivu';
export const ORG_SUBSCRIPTION = 'Organization Subscription';
export const DEFAULT_ORG_NAME = 'pycube';
export const DEFAULT_ORG_DISPLAY_NAME = 'Pycube Inc.';
export const APP_SETTING = 'App Setting';
export const APP_SOLUTION_REF = 'App Solutions';
export const ORGANIZATION = 'Organization';
export const DEPARTMENTS = 'Department';
export const FACILITIES = 'Facilities';
export const DEPT_FACILITY = 'Department / Facilities';
export const ORG_CATEGORY = 'Organization Categories';
export const CATEGORY = 'Categories';
export const FACILITY_CATEGORY = 'Facility Product Categories';
export const DEFAULT_ORG_CATGORY = 'Misc.';
export const DEFAULT_ASSET_GROUP = 'Default Asset Group';
export const DEFAULT_BUILDING = 'Default Building';
export const DEFAULT_FLOOR = 'Default Floor';
export const DEFAULT_ZONE = 'Default Zone';
export const VENDOR = 'Vendors';
export const FACILITY_PRODUCT = 'Facility Product';
export const PRODUCT = 'Product';
export const RECALL = 'Recall';
export const ASSET_GROUP = 'Asset Groups';
export const CONTACT = 'Contacts';
export const ASSET = 'Assets';
export const USER_LIST = 'Asset Locator';
export const MAINTENANCE_LOG = 'Maintenance Log';
export const ORG_GROUP = 'Organization Groups';
export const ORG_ROLE = 'Roles';
export const TICKET = 'Tickets';
export const INCIDENT = 'Incidents';
export const BUILDING = 'Buildings';
export const FLOOR = 'Floors';
export const ZONE = 'Zones';
export const LAUNDRY_LOSS_PREVENTION_LOG =
  'Laundry Loss Prevention Log';
export const NO_STATUS = 1;
export const OPEN = 2;
export const PENDING = 3;
export const CLOSED = 4;
export const A_IN_FACILITY = 5;
export const A_UNDER_MAINTENANCE = 6;
export const A_UNDER_REPAIR = 7;
export const A_RETIRED = 8;
export const A_LOST = 9;
export const PM_OPEN = 10;
export const PM_IN_USE = 11;
export const PM_COLLECTED = 12;
export const PM_COMPLETED = 13;
export const PM_CANCELLED = 14;
export const RECALL_STATUS = 15;
export const RECALL_COMPLETED = 16;
export const ULA_OPEN = 17;
export const ULA_COLLECTED = 18;
export const ULA_FLAGGED = 19;
export const UAL_INCOMPLETE = 20;
export const UAL_COMPLETED = 21;
export const UAL_CANCELLED = 22;
export const LLP_LOST = 23;
export const LLP_RETRIEVED = 24;
export const LLP_RFID_TAG_ONLY = 25;
export const PYCUBE_ADMIN = 'Pycube Admin';
export const CSM = 'CSM';
export const ADMIN = 'Admin';
export const DEPARTMENT_CHIEF = 'Department Chief';
export const TECHNICIAN = 'Technician';

// reg ex checks
export const NO_SPECIALS = /^[\w\-\s]+$/;
export const NO_SPECIALS_MESSAGE =
  'Special characters are not allowed';

export const COMMA_SPACE_PERIOD = /^[-a-zA-Z0-9,. ]*$/;

export const MEDIUM_DIALOG = {
  fullWidth: true,
  maxWidth: 'md',
};

export const SMALL_DIALOG = {
  fullWidth: true,
  maxWidth: 'sm',
};

export const LARGE_DIALOG = {
  fullWidth: true,
  maxWidth: 'lg',
};

export const XL_DIALOG = {
  fullWidth: true,
  maxWidth: 'xl',
};

export const SUPERUSER = 'superuser';
export const READ_ONLY = 'read_only';
